import * as React from "react";

import { cn } from "../../lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const inputVariants = cva(
  "jobsite:file:text-foreground jobsite:placeholder:text-muted-foreground jobsite:selection:bg-primary jobsite:selection:text-primary-foreground jobsite:dark:bg-input/30 jobsite:border-input jobsite:h-9 jobsite:w-full jobsite:min-w-0 jobsite:border jobsite:bg-transparent jobsite:px-3 jobsite:py-1 jobsite:text-base jobsite:transition-[color,box-shadow] jobsite:outline-none jobsite:file:inline-flex jobsite:file:h-7 jobsite:file:border-0 jobsite:file:bg-transparent jobsite:file:text-sm jobsite:file:font-medium jobsite:disabled:pointer-events-none jobsite:disabled:cursor-not-allowed jobsite:disabled:opacity-50 jobsite:md:text-sm jobsite:focus-visible:border-ring jobsite:focus-visible:ring-ring/50 jobsite:focus-visible:ring-[3px] jobsite:aria-invalid:ring-destructive/20 jobsite:dark:aria-invalid:ring-destructive/40 jobsite:aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "",
        rounded: "jobsite:rounded-md",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Input({
  className,
  type,
  variant = "default",
  ...props
}: React.ComponentProps<"input"> & VariantProps<typeof inputVariants>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(inputVariants({ variant, className }))}
      style={{ borderRadius: "var(--jobsite-radius)" }}
      {...props}
    />
  );
}

export { Input };
